import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}
export function getyuanliao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/page/material',
		method: 'post',
		data: obj
	})
}

// 分页查询供应商
export function getSupplier (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplier/page',
		method: 'post',
		data: obj
	})
}

// 获取所有供应商
export function getAllSupplier (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplier/list/supplier',
		method: 'post',
		data: obj
	})
}

// 新增供应商
export function addSupplier (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplier/add',
		method: 'post',
		data: obj,
		encryption: ['linkmanNumber']
	})
}

// 修改供应商
export function editSupplier (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplier/edit',
		method: 'post',
		data: obj,
		encryption: ['linkmanNumber']
	})
}

// 获取供应商资质列表
export function getSupplierDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplierqualification/page',
		method: 'post',
		data: obj
	})
}

// 修改供应商资质列表
export function updateSupplierDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplierqualification/edit',
		method: 'post',
		data: obj
	})
}

// 添加供应商资质列表
export function addSupplierDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplierqualification/add',
		method: 'post',
		data: obj
	})
}

// 删除供应商资质列表
export function delSupplierDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = {}
	}
	return request({
		url: `/api/v1/drpsupplierqualification/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 获取供应商级别
export function getSupplierList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplierlevel/list',
		method: 'post',
		data: obj
	})
}

// 修改供应商级别
export function updateSupplierList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplierlevel/edit',
		method: 'post',
		data: obj
	})
}

// 根据id删除供应商
export function delSupplier (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drpsupplier/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 更改供应商状态
export function changeSupplierStatus (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpsupplier/edit/status',
		method: 'post',
		data: obj
	})
}

// 获取全部采购员信息
export function getBuyer (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/all/buyer/list',
		method: 'post',
		data: obj
	})
}

// 新增采购计划保存
export function addSavePurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/add/save',
		method: 'post',
		data: obj
	})
}

// 新增采购计划发布
export function addCommitPurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/add/commit',
		method: 'post',
		data: obj
	})
}

// 分页获取采购计划
export function getPurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/page',
		method: 'post',
		data: obj
	})
}

// 修改采购计划保存
export function editSavePurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/edit/save',
		method: 'post',
		data: obj
	})
}

// 修改采购计划发布
export function editCommitPurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/edit/commit',
		method: 'post',
		data: obj
	})
}

// 删除采购计划
export function delPurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drppurchaseplan/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 分页获取采购订单
export function getPurOrd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseorder/page',
		method: 'post',
		data: obj
	})
}

// 变更采购订单状态
export function changePurOrdStatus (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseorder/edit/status',
		method: 'post',
		data: obj
	})
}
// 计算菜品原料数量
export function converCaipin (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpdishesconversion/calculate/material',
		method: 'post',
		data: obj
	})
}
// 发送邮件
export function sendEmail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/send/email',
		method: 'post',
		data: obj
	})
}

// 分页查看采购通知
export function getPurnotice (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurnotice/page/pur/notice',
		method: 'post',
		data: obj
	})
}

// 分页获取供货单信息
export function getSupplierSingle (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-supplier-single/page',
		method: 'post',
		data: obj
	})
}

// 修改供货单
export function updateSupplierSingle (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-supplier-single/edit',
		method: 'post',
		data: obj
	})
}

// 询价查询
export function getInquiry (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinquiry/page',
		method: 'post',
		data: obj
	})
}

// 取消询价
export function cancelInquiry (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinquiry/cancel',
		method: 'post',
		data: obj
	})
}

// 提交询价单
export function commitInquiry (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinquiry/commit',
		method: 'post',
		data: obj,
		encryption: ['phone']
	})
}

// 删除待提交的询价
export function delInquiry (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinquiry/delete',
		method: 'post',
		data: obj
	})
}

// 采购单导入询价单
export function purchaseImportInquiry (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinquiry/purchaseImportInquiry',
		method: 'post',
		data: obj
	})
}

// 新增询价单
export function addInquiry (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinquiry/save',
		method: 'post',
		data: obj,
		encryption: ['phone']
	})
}

// 查询报价单
export function getQuote (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpquote/page',
		method: 'post',
		data: obj
	})
}

// 供应商报价
export function updateQuote (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpquote/quote',
		method: 'post',
		data: obj,
		encryption: ['phone']
	})
}

// 导出采购单
export function exportPurplan (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/purPlan',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出盘点
export function exportCheckTable (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/checkTable',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出询价单
export function exportInquiryTable (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/inquiryTable',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出入库单
export function exportIntoTable (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/intoTable',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出出库单
export function exportOutTable (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/outTable',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出报价单
export function exportQuoteTable (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/quoteTable',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出供货单
export function exportSupplierSingle (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/supplierSingle',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 导出决标单
export function exportFinalBids (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/finalBids',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}

// 决标查询
export function finalBidsQuery (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpquote/finalBidsQuery',
		method: 'post',
		data: obj
	})
}

// 采购员点击决标报价按钮
export function finalBidsQueryButton (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpquote/finalBidsQuote',
		method: 'post',
		data: obj
	})
}

// 提交决标--采购员选择供应商
export function commitBidsQuery (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpquote/commitFinalBids',
		method: 'post',
		data: obj,
		encryption: ['phone']
	})
}

// 分页获取导入采购详情
export function getImportPurchase (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/import/page',
		method: 'post',
		data: obj
	})
}
